/**
 * Centralized API and Keycloak Configuration
 * 
 * This file acts as the single source of truth for all network URLs.
 * It reads from environment variables (VITE_*) and provides fallbacks.
 */

// Base network URL - defaulting to network IP
const DEFAULT_HOST = 'http://localhost';
const LOCAL_HOST = 'http://localhost'; // Keep as backup reference if needed

// Keycloak Config
export const KEYCLOAK_CONFIG = {
    url: import.meta.env.VITE_KEYCLOAK_URL || `${DEFAULT_HOST}:8080`,
    realm: import.meta.env.VITE_KEYCLOAK_REALM || 'yaseero-platform',
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'yaseero-client',
};

// Backend API Config
// Use relative URL with application context to leverage Vite proxy and avoid CORS
// The proxy in vite.config.js will forward /yaseero-backend/api/* to the backend
export const API_CONFIG = {
    baseUrl: '/yaseero-backend/api',
    // Add other specific service URLs here if they diverge from the base URL
};

// Application Config
export const APP_CONFIG = {
    environment: import.meta.env.MODE || 'development',
    isProduction: import.meta.env.PROD,
    isDevelopment: import.meta.env.DEV,
};
